export default __webpack_public_path__ + "static/about-4-0f30f974f10ff6e69ffca103bbf848d1.webp";